/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col } from 'reactstrap';
import {
  BarChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Bar, LabelList
} from 'recharts';
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
import { setCurrencyFormat, colorsCombination } from '../../../../utils/helpers';

export const CustomTooltip = (props) => {
  // eslint-disable-next-line react/prop-types
  const { active, payload } = props;
  // we don't need to check payload[0] as there's a better prop for this purpose
  if (!active) {
    // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
    return null
  }
  // mutating props directly is against react's conventions
  // so we create a new payload with the name and value fields set to what we want
  // eslint-disable-next-line react/prop-types

  const newPayload = Object.values(payload).sort((a, b) => a.value < b.value ? 1 : -1)

  // we render the default, but with our overridden payload
  return <DefaultTooltipContent {...props} payload={newPayload} />;
};


const MonthlyOrderBarChart = ({
  dir, data,
  height,
  allCategories
}) => (
  <div dir="ltr">
    <ResponsiveContainer height={height}>
      <BarChart
        data={data}
        margin={{
          top: 25, right: 0, left: 25, bottom: 0,
        }}
      >
        <XAxis dataKey="title" reversed={dir === 'rtl'} />
        <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
          tickFormatter={item => setCurrencyFormat(item, false)}
          width={90}
          allowDataOverflow
        />
        <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        {allCategories?.map((categ, index) => (
          <Bar stackId="1" type="monotone" dataKey={categ?.toString()} fill={colorsCombination[index % 10][0] || '#3366ff'} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  </div>
);

MonthlyOrderBarChart.propTypes = {
  dir: PropTypes.string.isRequired,
  allCategories: PropTypes.array.isRequired,
  height: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired
};


export default MonthlyOrderBarChart;
